var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.75 10.689 6.47-6.47a.749.749 0 1 1 1.06 1.06l-6.47 6.47 6.47 6.47a.749.749 0 1 1-1.06 1.06l-6.47-6.468-6.47 6.469a.749.749 0 1 1-1.06-1.06l6.469-6.47-6.47-6.47a.749.749 0 1 1 1.06-1.06l6.47 6.469z",
    clipRule: "evenodd"
  })));
};
export default SvgX;